export const MODULE_OVERVIEW = "intent";
export const MODULE_ANALYTIC = "analytic";

export const FILTER_SEARCH = 1;
export const SAVED_SEARCH = 2;
export const SAVED_LIST = 3;

export const months = [
  "jan",
  "feb",
  "mar",
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
];

export const fullMonthMap = {
  "01": "January",
  "02": "February",
  "03": "March",
  "04": "April",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "August",
  "09": "September",
  10: "October",
  11: "November",
  12: "December",
};

export const monthMap = {
  "01": "Jan",
  "02": "Feb",
  "03": "Mar",
  "04": "Apr",
  "05": "May",
  "06": "June",
  "07": "July",
  "08": "Aug",
  "09": "Sept",
  10: "Oct",
  11: "Nov",
  12: "Dec",
};

export const localeMap = new Map([
  ["en", "en"],
  ["zh_cn", "zh-cn"],
  ["zh_hk", "zh-tw"],
  ["ja", "ja"],
  ["hi", "hi"],
  ["ko", "ko"],
]);

export const readableTimeLocaleMap = new Map([
  ["en", "en"],
  ["zh_cn", "zh_CN"],
  ["zh_hk", "zh_TW"],
  ["ja", "ja"],
  ["hi", "hi"],
  ["ko", "ko"],
]);

export const mainWebsiteLocaleMap = new Map([
  ["en", "en"],
  ["zh_cn", "zh-CN"],
  ["zh_hk", "zh-HK"],
  ["ja", "ja"],
  ["hi", "hi"],
  ["ko", "ko"],
]);

export const docsLocaleMap = new Map([
  ["en", "en"],
  ["zh_cn", "cn"],
  ["zh_hk", "en"],
  ["ja", "ja"],
  ["hi", "en"],
  ["ko", "ko"],
]);
